import { HasPlan } from ".";
import { UserPlanEnum } from "../../constants/plans";

export const planos = [
  {
    type: UserPlanEnum.VELOTAX_MAIN_BASIC,
    name: "Basic",
    price: 25.9,
    originalPrice: 25.9,
    installments: 12,
    fullPrice: 310.8,
    for: "Pra quem começou a investir agora",
    includes: "Basic inclui:",
    benefits: [
      "Cálculos automáticos de IR",
      "Emissão de DARF do mês corrente",
    ],
  },
  {
    type: UserPlanEnum.VELOTAX_MAIN_BASIC_MONTH,
    name: "Basic",
    price: 45.9,
    originalPrice: 45.9,
    installments: 12,
    fullPrice: 550.8,
    for: "Pra quem começou a investir agora",
    includes: "Basic inclui:",
    benefits: [
      "Cálculos automáticos de IR",
      "Emissão de DARF do mês corrente",
    ],
  },
  {
    type: UserPlanEnum.VELOTAX_MAIN_PRO,
    name: "Premium",
    price: 59.9,
    originalPrice: 59.9,
    installments: 12,
    fullPrice: 718.8,
    for: "Pra quem investe com maior frequência",
    includes: "Tudo do Basic, mais:",
    benefits: [
      "Informes de rendimento em PDF",
      "DARFs retroativos ilimitados",
      "Carteira de investimentos atualizada",
      "Notificações de dividendos",
      "Isentômetro de impostos",
    ],
  },
  {
    type: UserPlanEnum.VELOTAX_MAIN_PRO_MONTH,
    name: "Premium",
    price: 79.9,
    originalPrice: 79.9,
    installments: 12,
    fullPrice: 958.8,
    for: "Pra quem investe com maior frequência",
    includes: "Tudo do Basic, mais:",
    benefits: [
      "Informes de rendimento em PDF",
      "DARFs retroativos ilimitados",
      "Carteira de investimentos atualizada",
      "Notificações de dividendos",
      "Isentômetro de impostos",
    ],
  },
  {
    type: UserPlanEnum.VELOTAX_MAIN_CONCIERGE,
    name: "Concierge",
    price: 79.9,
    originalPrice: 79.9,
    installments: 12,
    fullPrice: 958.8,
    for: "Pra quem não quer ter nenhum trabalho",
    includes: "Tudo do Premium, mais:",
    benefits: [
      "Especialista dedicado para você",
      "DARFs revisadas por profissional",
      "Contato por WhatsApp exclusivo",
    ],
    popular: true,
  },
  {
    type: UserPlanEnum.VELOTAX_MAIN_CONCIERGE_MONTH,
    name: "Concierge",
    price: 99.9,
    originalPrice: 99.9,
    installments: 12,
    fullPrice: 1198.8,
    for: "Pra quem não quer ter nenhum trabalho",
    includes: "Tudo do Premium, mais:",
    benefits: [
      "Especialista dedicado para você",
      "DARFs revisadas por profissional",
      "Contato por WhatsApp exclusivo",
    ],
    popular: true,
  },
];

export enum UserPlanUpgradeEnum {
  BASIC_TO_PRO = "BASIC_TO_PRO",
  BASIC_TO_CONCIERGE = "BASIC_TO_CONCIERGE",
  PRO_TO_CONCIERGE = "PRO_TO_CONCIERGE",
}

export const planUpgrade = {
  [UserPlanUpgradeEnum.BASIC_TO_PRO]: 40,
  [UserPlanUpgradeEnum.BASIC_TO_CONCIERGE]: 60,
  [UserPlanUpgradeEnum.PRO_TO_CONCIERGE]: 20,
};

export const getPlanPrice = (
  plan: { price: number; type: UserPlanEnum },
  hasPlan: false | HasPlan
) =>
  !hasPlan
    ? plan?.price
    : hasPlan.premium && plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE
    ? planUpgrade[UserPlanUpgradeEnum.PRO_TO_CONCIERGE]
    : hasPlan.basic && plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO
    ? planUpgrade[UserPlanUpgradeEnum.BASIC_TO_PRO]
    : hasPlan.basic && plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE
    ? planUpgrade[UserPlanUpgradeEnum.BASIC_TO_CONCIERGE]
    : plan?.price;

export const getPlanOriginalPrice = (
  plan: { originalPrice: number; type: UserPlanEnum },
  hasPlan: false | HasPlan
) =>
  !hasPlan
    ? plan?.originalPrice
    : hasPlan.premium && plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE
    ? planUpgrade[UserPlanUpgradeEnum.PRO_TO_CONCIERGE]
    : hasPlan.basic && plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO
    ? planUpgrade[UserPlanUpgradeEnum.BASIC_TO_PRO]
    : hasPlan.basic && plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE
    ? planUpgrade[UserPlanUpgradeEnum.BASIC_TO_CONCIERGE]
    : plan?.originalPrice;

    export const calculatePlanPrice = (
      plan: { originalPrice: number; type: UserPlanEnum },
      hasPlan: false | HasPlan,
      basicPlanPrice: number,
      proPlanPrice: number,
      conciergePlanPrice: number,
    ) => {
      if(!hasPlan && plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO) return proPlanPrice
      if(!hasPlan &&  plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE) return conciergePlanPrice
      if (!hasPlan) return plan?.originalPrice
      if (hasPlan.basic && plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO) return proPlanPrice - basicPlanPrice;
      if (hasPlan.basic && plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE) return conciergePlanPrice - basicPlanPrice;
      if (hasPlan.premium && plan?.type === UserPlanEnum.VELOTAX_MAIN_PRO) return proPlanPrice;
      if (hasPlan.premium && plan?.type === UserPlanEnum.VELOTAX_MAIN_CONCIERGE) return conciergePlanPrice - proPlanPrice;
    }